import { type UseQueryResult, useQuery } from 'react-query';
import {
  TwoFactorConfigurationService,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Dtos_TwoFactor_TwoFactorConfigurationDto } from '@wealthlane/api-services/wealthlane-identity-service';

const useGetTwoFactorConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Wealthlane_Dtos_TwoFactor_TwoFactorConfigurationDto | undefined, unknown> => {
  return useQuery(['getTwoFactorConfiguration'], async () => {
    return await handleRequest(
      TwoFactorConfigurationService.getApiIdentityApiTwoFactorConfiguration()
    );
  });
};

export default useGetTwoFactorConfiguration;
